import { Card, CardContent } from '@/components/ui/card'
import { Field, FieldGroup } from '@/components/ui/field'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import type { OrgBusiness } from '../../../../models/business'

export function BusinessTab({ business }: { business: OrgBusiness | null }) {
  if (!business) {
    return (
      <Card>
        <CardContent>
          <p className="text-muted-foreground text-sm">No motor carrier associated with this organization.</p>
        </CardContent>
      </Card>
    )
  }

  return (
    <div className="flex flex-col gap-5">
      <Card>
        <CardContent>
          <div className="grid gap-4 lg:grid-cols-[1fr_2fr]">
            <FieldGroup className="max-w-sm">
              <Field>
                <Label>Name</Label>
                <Input value={business.name || ''} disabled />
              </Field>
              <div className="grid grid-cols-2 gap-4">
                <Field>
                  <Label>DOT Number</Label>
                  <Input value={business.dotNumber || ''} disabled />
                </Field>
                <Field>
                  <Label>MC Number</Label>
                  <Input value={business.mcNumber || ''} disabled />
                </Field>
              </div>
            </FieldGroup>
            {business.address && (
              <FieldGroup className="max-w-sm">
                <Field>
                  <Label>Address Line 1</Label>
                  <Input value={business.address.line1 || ''} disabled />
                </Field>
                <Field>
                  <Label>Address Line 2</Label>
                  <Input value={business.address.line2 || ''} disabled />
                </Field>
                <div className="grid grid-cols-3 gap-4">
                  <Field>
                    <Label>City</Label>
                    <Input value={business.address.city || ''} disabled />
                  </Field>
                  <Field>
                    <Label>State</Label>
                    <Input value={business.address.state || ''} disabled />
                  </Field>
                  <Field>
                    <Label>ZIP</Label>
                    <Input value={business.address.zip || ''} disabled />
                  </Field>
                </div>
              </FieldGroup>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  )
}
